<template>
  <div class="flex items-center border-b border-black" style="height: 46px">
    <div class="mx-4" style="color: #a1a1a1">
      <i class="fas fa-search"></i>
    </div>
    <input
      :id="name"
      :name="name"
      :value="value"
      type="text"
      :placeholder="placeholder"
      @input="onInput"
      class="w-full text-secondary3 leading-tight focus:outline-none py-1"
    >
  </div>
</template>

<script>
import debounce from "lodash/debounce"

export default {
  name: "CustomSearchBar",
  props: {
    name: { type: String, required: false, default: "search-bar" },
    value: { type: String, required: true },
    placeholder: { type: String, required: false }
  },
  data() {
    return {
      error: null
    }
  },
  methods: {
    onInput: debounce(function(event) {
      this.$emit("update:value", event.target.value)
    }, 500)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CustomSearchBar.vue